// @flow
import React, { Fragment, Component } from 'react';
import type { BlocContent } from 'types/NewsletterBloc';

import ContactFormAccreditations from 'containers/contact/ContactFormAccreditationsContainer';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

type Props = {
  content: Array<BlocContent>,
};

class PageHubAccreditations extends Component<Props> {
  renderDetail = () => {
    const { content } = this.props;
    return content.map<any>((blocFigure, index) => {
      return <ContentBloc key={index} {...blocFigure} />;
    });
  };

  render() {
    return (
      <Fragment>
        <div className="page">
            {this.renderDetail()}
            <ContactFormAccreditations />
        </div>
      </Fragment>
    );
  }
}

export default PageHubAccreditations;
